module.exports = __webpack_public_path__ + "assets/c691af22af0bf38c5c7716565bbbd6fc.mp3";